import organisationAPI from '@/api/organisationsAPI.js';

const state = {
  organisationsTypes: [],
};

const getters = { };

const actions = {
  GET_ORGANISATIONS_TYPES: async ({ commit }) => {
    const types = await organisationAPI.getOrganisationsTypes();
    commit('SET_ORGANISATIONS_TYPES', types);
  },
};

const mutations = {
  SET_ORGANISATIONS_TYPES: (state, payload) => {
    state.organisationsTypes = payload;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
